<template>
  <ul class="case-study-images">
    <li
      :class="{ show: index == active }"
      v-for="(slide, index) in slides"
      :key="index"
    >
      <div
        class="img-hero-background no-blur"
        :style="{ backgroundImage: `url(${slide.image})` }"
      ></div>
      <h2 class="fullscreen-image no-blur">{{ slide.name }}</h2>
      <div class="hero-number">{{ currentSlide }}</div>
      <div class="hero-number-fixed">
        {{ maxSlides }}
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    active: {
      type: Number,
      default: 0
    },
    slides: {
      type: Array
    }
  },
  watch: {
    active(val) {
      if (val + 1 === this.slides.length) {
        this.fetchCases();
      }
    }
  },
  computed: {
    maxSlides() {
      return this.slides.length < 10
        ? `0${this.slides.length}`
        : this.slides.length;
    },
    currentSlide() {
      return this.active + 1 < 10 ? `0${this.active + 1}` : this.active + 1;
    }
  },
  methods: {
    ...mapActions({
      fetchCases: "caseStudies/fetchCaseStudies"
    })
  }
};
</script>

<style lang="scss" scoped>
.case-study-images {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 1;
}
.case-study-images li {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  list-style: none;
  transition: all 300ms linear;
}
.case-study-images li .img-hero-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  overflow: hidden;
  list-style: none;
  opacity: 0;
  z-index: 5;

  transition: all 300ms linear;
}

.case-study-images li .img-hero-background.no-blur {
  -webkit-clip-path: none;
  clip-path: none;
}

.case-study-images li.show .img-hero-background.no-blur {
  opacity: 0.45;
}
.case-study-images li h2 {
  position: absolute;
  width: 300%;
  text-align: center;
  font-size: 16vw;
  line-height: 0.8;
  color: rgba(200, 200, 200, 0.1);
  background: linear-gradient(rgba(75, 77, 100, 0.8), rgba(75, 77, 100, 0));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  bottom: 0;
  left: -100%;
  list-style: none;
  opacity: 0;
  z-index: 7;
  -webkit-transform: translateY(-30px);
  transform: translateY(-30px);

  transition: all 300ms linear;
}

.case-study-images li h2.fullscreen-image {
  color: #353746;
}

.case-study-images li h2.fullscreen-image.no-blur {
  background: none;
  -webkit-background-clip: #353746;
  -webkit-text-fill-color: #353746;
  color: #353746;
  mix-blend-mode: screen;
}

.case-study-images li.show h2 {
  opacity: 1;
  transform: translateY(0);
}
.case-study-images li .img-hero-background-over {
  position: absolute;
  width: 60%;
  height: 60%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  top: 20%;
  left: 20%;
  overflow: hidden;
  list-style: none;
  opacity: 0;
  z-index: 8;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  transition: all 300ms linear;
}
.case-study-images li .img-hero-background-over:after {
  position: absolute;
  content: "";
  left: 0;
  height: 100%;
  top: 0px;
  background-color: #111;
  width: 100%;
  z-index: 9;
  opacity: 0.3;
}
.case-study-images li.show .img-hero-background {
  opacity: 0.5;
}
.case-study-images li.show .img-hero-background-over {
  opacity: 1;
}
.case-study-images li .hero-number-fixed {
  position: absolute;
  bottom: 70px;
  left: 50%;
  width: 40px;
  text-align: center;
  display: block;
  letter-spacing: 2px;
  list-style: none;
  font-size: 13px;
  margin-left: 30px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  line-height: 1;
  color: #fff;
  z-index: 6;
}

.case-study-images li .hero-number-fixed:before {
  position: absolute;
  content: "";
  top: 50%;
  left: -60px;
  width: 60px;
  height: 1px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.6);
}
.case-study-images li .hero-number {
  position: absolute;
  bottom: 70px;
  left: 50%;
  width: 40px;
  margin-left: -70px;
  text-align: center;
  display: block;
  letter-spacing: 2px;
  list-style: none;
  opacity: 0;
  font-size: 13px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  line-height: 1;
  color: #fff;
  z-index: 6;
  transform: translateY(100%);

  transition: all 300ms linear;
}
.case-study-images li.show .hero-number {
  opacity: 1;
  transform: translateY(0);
}
</style>
